/* Backtrack Vinyl — barra de envío gratis (Claude, v4: azul #0c4860 + 🛒 en carrito vacío) */
(function(){
  var UMBRAL = 2499; // <-- cambiar aquí si baja el umbral de envío gratis
  function init(){
    if(document.getElementById('bt-envio-bar')) return;
    var bar = document.createElement('div');
    bar.id = 'bt-envio-bar';
    bar.style.cssText = 'background:#0c4860;color:#fff;font-size:13px;text-align:center;padding:7px 12px;position:relative;z-index:1;';
    bar.innerHTML = '<span id="bt-envio-txt"></span><div style="height:3px;background:rgba(255,255,255,.25);border-radius:2px;margin-top:5px;max-width:340px;margin-left:auto;margin-right:auto;overflow:hidden;"><div id="bt-envio-prog" style="height:100%;width:0%;background:#e8a33d;border-radius:2px;transition:width .4s;"></div></div>';
    var header = document.querySelector('header');
    if(header && header.parentElement){ header.parentElement.insertBefore(bar, header.nextSibling); } else { document.body.insertBefore(bar, document.body.firstChild); }
    refresh();
  }
  function fmt(n){ return '$' + Math.ceil(n).toLocaleString('es-MX'); }
  function render(total){
    var t = document.getElementById('bt-envio-txt'), p = document.getElementById('bt-envio-prog');
    if(!t || !p) return;
    if(total <= 0){ t.textContent = 'Envío GRATIS en pedidos de ' + fmt(UMBRAL) + '+ 🛒'; p.style.width = '0%'; }
    else if(total >= UMBRAL){ t.innerHTML = '🎉 ¡Tienes envío GRATIS en tu pedido!'; p.style.width = '100%'; }
    else { t.innerHTML = 'Te faltan <b>' + fmt(UMBRAL - total) + '</b> para el envío GRATIS 🚚'; p.style.width = Math.max(6,(total/UMBRAL*100)).toFixed(0) + '%'; }
  }
  var pending = null;
  function refresh(){
    if(pending) return; 
    pending = setTimeout(function(){
      pending = null;
      fetch('/cart.js').then(function(r){ return r.json(); }).then(function(c){ render(c.total_price/100); }).catch(function(){});
    }, 400);
  }
  var _fetch = window.fetch;
  window.fetch = function(){
    var url = (arguments[0] && arguments[0].url) || arguments[0] || '';
    var p = _fetch.apply(this, arguments);
    if(typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url)){ p.then(refresh); }
    return p;
  };
  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(m, url){
    if(typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url)){ this.addEventListener('loadend', refresh); }
    return _open.apply(this, arguments);
  };
  document.addEventListener('cart:update', refresh);
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
